import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider, useAppState, useFacet, useProductFilters } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import Facets from "../elements/facetsData";
import FacetPanel from './FacetPanel'
import { CheckboxV2 as Checkbox } from "../elements/";
import { useCustomConfig } from "../../hooks/useCustomConfig"

export default function RangeFacetCustom({ facet }) {
    const rangesArr = [
        { min: 1, max: 10, count: 0 },
        { min: 10, max: 25, count: 0 },
        { min: 25, max: 50, count: 0 },
        { min: 50, max: 75, count: 0 },
        { min: 75, max: 100, count: 0 },
    ]
    const {
        response: { products },
        loading
    } = useAppState()

    const { customConfig } = useCustomConfig()

    const { min, max, range, updateRange } = useRangeSlider(facet.id)

    const [ranges, setRanges] = useState(rangesArr);
    const { filters } = useProductFilters()

    useEffect(() => {
        nostojs(api => {
            api.search({
                products: {
                    categoryId: products.categoryId,
                    categoryPath: products.categoryPath,
                    fields: ['price'],
                    size: products.total
                }
            }).then(response => {

                const updatedRanges = ranges.map(range => {
                    let productSelect = filters.length > 0 ? products : response.products
                    const count = productSelect.hits.filter(
                        product => product.price >= range.min && product.price <= range.max
                    ).length;
                    return { ...range, count };
                });
                setRanges(updatedRanges);

            }).catch(error => {
                console.error('Error:', error);
            });
        });
    }, [products]);

    return (
        <FacetPanel 
            panelName={facet.name} 
            showMoreButton={false}>
                {ranges?.map((value) =>
                    value.count > 0 && (
                        <div
                            className="item"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={`$${value.min} - $${value.max}`}
                                selected={value.min == range[0] && value.max == range[1]}
                                onChange={(e) => {
                                    e.preventDefault();
                                    updateRange([value.min, value.max]);
                                }}
                            />
                            {customConfig.filters.showProductCount && <span className="">({value.count})</span>}
                        </div>
                    )
                )}
        </FacetPanel>
    )
}
